module.exports = __webpack_public_path__ + "static/media/SWSCRC2-05.e6c9791b.mp3";